import React, { useEffect, useState } from "react";
import { fetchRuntimeFormData } from "../services/FormService";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CONSTANTS, { INSURER_PORTAL_ACCESS_URLS } from "../constants/constants";
import { pushNotification } from "../redux/actions";
import { useDispatch } from "react-redux";
import Colors from "../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  InsurePortalUrlsContainer: {
    width: "100%",
    height: "100%",
  },
  InsurePortalUrlsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "1vh",
    "@media (min-width: 2000px)": {
      padding: "3.3%  2% 2% 2%",
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      padding: "3.3%  2% 2% 2%",
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      padding: "4.3%  2% 2% 2%",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      padding: "7%  2% 2% 2%",
    },
    "@media (max-width: 600px)": {
      padding: "10%  2% 2% 2%",
    },
  },
  table: {
    background: Colors.WHITE_BACKGROUND,
    minWidth: 650,
    borderCollapse: "collapse", // Collapse borders
    "& thead": {
      position: "sticky",
      top: 0,
      background: theme.palette.background.paper,
      zIndex: 0,
    },
    "& tbody": {
      textAlign: "center",
    },
    "& th, & td": {
      // border: "1px solid lightgray",
      // padding: "10px",
      textAlign: "left",
    },
  },
  tableContainer: {
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)",
    borderRadius: 8,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "0.7vw",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: `${theme.palette.secondary.main}50`,
      borderRadius: 6,
    },
  },
  tableHeading: {
    backgroundColor: `${theme.palette.primary.main}`,
    // fontWeight: "bold",
    color: theme.palette.primary.contrastText,
    padding: "0.3rem 0.3rem 0.3rem 0.8rem",
    // textAlign: "center",
    border: `1px solid ${Colors.BORDER}`,
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 700,
  },
  hyperlink: {
    padding: "0.3rem 0.3rem 0.3rem 0.3rem",
    color: theme.palette.primary.main,
    fontSize: theme.fontSizes.SMALL,
  },

  tableCellData: {
    padding: "0.3rem 0.3rem 0.3rem 0.8rem",
    fontSize: theme.fontSizes.SMALL,
    // textAlign: "center",
    border: `1px solid ${Colors.BORDER}`,
  },
}));

function InsurerPortalAccessUrls() {
  const dispatch = useDispatch();
  const [insurerUrlData, setInsurerUrlData] = useState<any>([]);
  const classes = useStyles();

  useEffect(() => {
    const fetchData = async () => {
      const response: any = await fetchRuntimeFormData(
        INSURER_PORTAL_ACCESS_URLS,
        0,
        1000
      );

      if (response?.success) {
        setInsurerUrlData(
          response.data.content[0].formData.insurerPortalAccessUrls
        );
        dispatch(
          pushNotification({
            isOpen: true,
            message: response.message,
            type: CONSTANTS.SUCCESS,
          })
        );
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            message: response.message,
            type: CONSTANTS.ERROR,
          })
        );
      }
    };
    fetchData();
  }, []);

  return (
    <div className={classes.InsurePortalUrlsContainer}>
      <div className={classes.InsurePortalUrlsSection}>
        {/* <h2>Insurer Portal Access URLs</h2> */}
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeading}>
                  Insurance Company
                </TableCell>
                <TableCell className={classes.tableHeading}>
                  Portal Link
                </TableCell>
                <TableCell className={classes.tableHeading}>
                  Product Category
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {insurerUrlData?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tableCellData}>
                    {row.insuranceCompany}
                  </TableCell>
                  <TableCell className={classes.hyperlink}>
                    <a
                      href={row.portalLink}
                      target="_blank"
                      className={classes.hyperlink}
                    >
                      Click Here
                    </a>
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {row.productCategory}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default InsurerPortalAccessUrls;
